<template>
  <section>
    <r-title>{{ $t("title") | titlecase }}</r-title>
    <div class="side-by-side">
      <p v-if="!branches">{{ $t("branches.is-loading") }}</p>
      <p v-else-if="!branches.length">{{ $t("branches.is-empty") }}</p>
      <p v-else>
        {{ $t("branches.prompt") }}
        <BranchSelect v-model="branch" :branches="branches" />
      </p>

      <p v-if="!branch" />
      <p v-else-if="!customers">
        {{ $t("customers.is-loading", { branch: branch.name }) }}
      </p>
      <p v-else-if="!customers.length">
        {{ $t("customers.is-empty") }}
      </p>
      <p v-else>
        {{ $t("customers.prompt") }}
        <CustomerSelect v-model="customer" :customers="customers" />
      </p>

      <TaskList
        v-if="customer"
        :tasks="tasks"
        show-finish-date
        show-state
        class="grid-span-2"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

import BranchSelect from "@/components/BranchSelect.vue";
import CustomerSelect from "@/components/CustomerSelect.vue";
import TaskList from "@/components/TaskList.vue";

export default {
  components: {
    BranchSelect,
    CustomerSelect,
    TaskList
  },
  i18nOptions: {
    keyPrefix: "views.log-all"
  },
  data() {
    return {
      branch: null,
      customer: null
    };
  },
  computed: {
    customers() {
      return this.branch && this.$store.getters.customers$1(this.branch.name);
    },
    tasks() {
      return (
        this.customer && this.$store.getters.finishedTasks$1(this.customer.name)
      );
    },
    ...mapGetters(["branches"])
  },
  watch: {
    branch(branch) {
      this.$store.dispatch("loadCustomers$1", branch);
      this.customer = null;
    },
    customer(customer) {
      this.$store.dispatch("loadFinishedTasks$1", customer);
    }
  },
  beforeCreate() {
    this.$store.dispatch("loadBranches");
    this.refreshHandler = window.setInterval(() => {
      if (this.customer) {
        this.$store.dispatch("loadFinishedTasks$1", this.customer);
      }
    }, 60 * 1000);
  },
  beforeDestroy() {
    window.clearInterval(this.refreshHandler);
  }
};
</script>

<style lang="scss" scoped>
.side-by-side {
  display: grid;
  grid-template-columns: 1fr 1fr;

  .grid-span-2 {
    grid-column: 1 / 3;
  }
}
</style>
